export default {
  getCouponName: state => state.coupon && state.coupon.name,
  getCouponPercentageOff: state => state.coupon && state.coupon.percentageOff,
  getCouponAmountOff: state => state.coupon && state.coupon.amountOff,
  getDiscountAmount: state => state.subtotal - state.total
}
